import React, { useState } from 'react';
import { Header, Icon, Popup } from 'semantic-ui-react';

import { useDispatch, useSelector } from 'react-redux';
import { CustomGroupUtils, PhoneUtil } from 'utils';
import {
    CloseableContent,
} from 'dyl-components';

import contactActions from 'actions/contact';
import sequenceTasksActions from 'actions/sequence_tasks';
import { NavLink, useParams } from 'react-router-dom';

import 'shared/ProfileControls.scss';
import ChangeModulePipelineForm from './ChangeModulePipelineForm';
import { ActivityPopup } from 'shared/forms/NewActivity';
import { TextMessageModal } from 'shared/modals';
import TextIcon from 'shared/TextIcon';
import EmailIcon from 'shared/EmailIcon';

const Controls = ({ popupRef }) => {
    const {
        parent_account,
        phone,
        mainPhone,
        current_pipeline_category,
        account_stage,

        master_source,
        secondary_source,
        module_custom_data,
        campaign_converted,
        account_id,
        userPhoneCreds,
        name,
        hasEmail
    } = useSelector(state => {
        const { first_name, last_name, suffix } = state.contact.contact || {};
        const custom_data = {};
        const contact_custom = state.contact.custom_data;
        contact_custom.fields.forEach(field => {
            custom_data[`fields|${field.field_name}`] = field.value;
        })
        const name = `${first_name || ''} ${last_name || ''}${suffix ? ` ${suffix}` : ''}`;
        const contactEmails = state.contact.email ? state.contact.email.slice(0).map(({ email }) => email) : [];

        let mainPhone = state.contact_phone.phone.find(item => item.main);

        if (!mainPhone) {
            mainPhone = state.contact_phone.phone[0] || { phone: '' }
        }

        const { master_source, secondary_source, campaign_converted } = state.contact.current_stage || {};
        
        return {
            name,
            phone: state.contact_phone.phone.length > 0 ? `${state.contact_phone.phone.find(phone => phone.main).phone}` : "",
            integration_id: state.oauth_integrations?.activeIntegration?.id,
            mainPhone: mainPhone.phone,
            parent_account: state.contact.account,
            current_pipeline_category: state.contact.current_stage?.pipeline_category_id,
            account_stage: state.contact.current_stage?.account_stage || "contact",
            master_source,
            secondary_source: secondary_source?.id || null,

            module_custom_data: CustomGroupUtils.groupAndFlatten(state.contact.current_stage?.custom_data || {}),

            campaign_converted: campaign_converted && Object.keys(campaign_converted).length > 1 && (Boolean(campaign_converted.id) && Boolean(campaign_converted.name)) ? campaign_converted.id : null,
            account_id: state.contact.account_id,
            primary_contact_id: state.contact.account.primary_contact_id,
            isCustomerAccount: state.contact.account.has_customer,
            userPhoneCreds: state?.officeView?.creds,
            hasEmailIntegrations: state.oauth_integrations.integrations?.length > 0,
            hasEmail: contactEmails.length > 0
        }
    });    
    const dispatch = useDispatch();
    const isPhoneSystemSupported = PhoneUtil.isPhoneSystemSupported(userPhoneCreds);

    const { contact_id } = useParams();
    const { id: parent_account_id } = parent_account || {};
    const locationParam = () => `contact/${contact_id}`;

    const [openForm, setOpenForm] = useState(null);
    const [isPipelineFormModified, setIsPipelineFormModified] = useState(false);
    const onCloseForm = () => {
        setOpenForm(null);
        setIsPipelineFormModified(false);
    }

    return (
        <React.Fragment>
            {isPhoneSystemSupported ? (
                <Icon
                    disabled={!phone}
                    onClick={() => {
                        PhoneUtil.C2D({
                            payload: {
                                contact_id: Number(contact_id) || null,
                                account_id: Number(account_id) || null,
                                destination: mainPhone,
                            },
                            dispatch,
                        });
                    }}
                    className="Profile__controls fas fa-phone"
                    link
                />
            ) : (
                <ActivityPopup
                    trigger={
                        <Icon
                            disabled={!phone}
                            className="Profile__controls fas fa-phone"
                            link
                        />
                    }
                    activityProps={{
                        hideActivitySelection: true,
                        contact: { id: Number(contact_id) },
                        isContact: true
                    }}
                    open={openForm === 'call'}
                    onOpen={() => setOpenForm('call')}
                    onClose={onCloseForm}
                    position="bottom right"
                />
            )}
            <TextIcon 
                account_id={account_id}
                contact_id={contact_id}
                isActivityFormOpen={openForm === 'text'}
                onCloseActivityForm={onCloseForm}
                onOpenActivityForm={() => {setOpenForm('text')}}
                onOpenTextModal={() => {setOpenForm('text-modal')}}
                phone={mainPhone}
                iconClassName="Profile__controls"
            />
            <EmailIcon 
                hasEmail={hasEmail}
                contact_id={contact_id}
                emailIconClassName={'Profile__controls'}
                onOpenEmailModal={() => {setOpenForm('email-modal')}}
                isEmailModalOpen={openForm === 'email-modal'}
                isActivityFormOpen={openForm === 'email'}
                onOpenActivityPopup={() => {setOpenForm('email')}}
                onClose={onCloseForm}
            />
            <Icon
                as={NavLink}
                to={`/${locationParam()}/notes`}
                link
                className="Profile__controls fa-sharp fa-solid fa-pen-clip"
                color="grey"
            />
            <Popup
                open={openForm === "change-pipeline"}
                position="bottom right"
                context={popupRef}
                onClose={onCloseForm}
                content={
                    <>
                        <Header color="primary">Change Pipeline</Header>
                        <CloseableContent onClose={onCloseForm}>
                            <ChangeModulePipelineForm
                                contact_id={contact_id}
                                onClose={onCloseForm}
                                refresh={() => {
                                    dispatch(
                                        contactActions.readContact(contact_id)
                                    );
                                    dispatch(
                                        sequenceTasksActions.readContactTasks(
                                            contact_id
                                        )
                                    );
                                }}
                                current_pipeline_category={
                                    current_pipeline_category
                                }
                                account_stage={account_stage}
                                account_id={parent_account_id}
                                campaign_converted={campaign_converted}
                                custom_data={module_custom_data}
                                master_source={master_source}
                                secondary_source={secondary_source}
                            />
                        </CloseableContent>
                    </>
                }
                closeOnDocumentClick={!isPipelineFormModified}
            />
            <TextMessageModal
                open={openForm === 'text-modal'}
                onClose={onCloseForm}
                contact_name={name}
                contact_id={contact_id}
            />
        </React.Fragment>
    );
};

export default Controls;

